<template>
  <div id="BottomLeft">
    <div id="lineChart" ref="lineChart"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  // 组件名称
  name: 'BottomLeft',
  data() {
    return {
      lineChart: null
    }
  },
  mounted() {
    this.initChart()
  },
  methods: {
    initChart() {
      this.lineChart = echarts.init(this.$refs.lineChart)
      const option = this.getOption()
      this.lineChart.setOption(option, true)
      window.addEventListener('resize', () => {
        this.lineChart.resize()
      })
    },
    getOption() {
      const options = {
        color: ['#12FEFD', '#35AAFF'],
        grid: {
          containLabel: true,
          bottom: '20',
          left: '10'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        legend: {
          show: true,
          right: '30%',
          top: 20,
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            /* '2021年9月',
            '2021年10月',
            '2021年11月', */
            '2021年12月',
            '2022年1月',
            '2022年2月'
          ],
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.5
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.65)',
              fontSize: 10
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          },
          {
            type: 'value',
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.65)',
              fontSize: 10
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          }
        ],
        series: [
          {
            name: 'PV',
            data: [479818, 485073, 134403],
            type: 'line',
            lineStyle: {
              width: 3
            }
          },
          {
            name: 'UV',
            yAxisIndex: 1,
            data: [11186, 11028, 2923],
            type: 'line',
            lineStyle: {
              width: 3
            }
          }
        ]
      }
      return options
    }
  }
}
</script>
<style scoped lang='scss'>
#BottomLeft {
  width: 100%;
  height: 100%;
  #lineChart {
    width: 100%;
    height: 100%;
  }
}
</style>
